<script setup>
    import { router } from '@inertiajs/vue3';

    const props = defineProps({
        toolkit: Object,
        actions: Array,
        loggedInUserId: Number,
    });

    const programme = router.page.props.ziggy.programme;
    const organisation = router.page.props.ziggy.organisation;
    const urlNamePrefix = organisation ? "gi." : "";

    // Set up widget variables
    const actions = props.actions;
    const currentUserID = props.loggedInUserId;
    const assignedActions = [];

    // Are there any actions to view?
    if (actions) {

        // Loop through each action and push any starred action to starredActions
        actions.forEach(function (action) {
            if ( action.actionCurrentAssignedUser[0].assigned_user == currentUserID ) {
                assignedActions.push(action);
            }
        });

        // Loop through starredActions and add new properties and values
        // These are status labels and status classes
        assignedActions.forEach(function (assignedAction) {
            // create ID to link to on Toolkit page
            assignedAction.actionID = assignedAction.reference.toLowerCase();
            const assignedActionID = assignedAction.actionID.replace(/\s/g, '');
            assignedAction.actionLink = route(urlNamePrefix+'toolkit.view') + '#' + assignedActionID;

            if ( assignedAction.actionCurrentStatus.length !== 0 ) {
                if ( assignedAction.actionCurrentStatus[0] == 1 ) {
                    assignedAction.actionCurrentStatusLabel = 'done';
                    assignedAction.actionCurrentStatusClass = 'action-done';
                }
                else if ( assignedAction.actionCurrentStatus[0] == 2 ) {
                    assignedAction.actionCurrentStatusLabel = 'in_progress';
                    assignedAction.actionCurrentStatusClass = 'action-in-progress';
                }
                else if ( assignedAction.actionCurrentStatus[0] == 3 ) {
                    assignedAction.actionCurrentStatusLabel = 'not_done';
                    assignedAction.actionCurrentStatusClass = 'action-not-done';
                }
                else if ( assignedAction.actionCurrentStatus[0] == 4 ) {
                    assignedAction.actionCurrentStatusLabel = 'not_applicable';
                    assignedAction.actionCurrentStatusClass = 'action-not-applicable';
                }
            }
            else {
                assignedAction.actionCurrentStatusLabel = 'none';
                assignedAction.actionCurrentStatusClass = 'action-no-status';
            }
        });
    }

</script>

<template>
    <div class="dashboard-widget widget actions-assigned-widget">
        <div class="flex justify-between widget-header">
            <span>{{ $t('dashboard.widgets.assigned.title') }}</span>
            <span class="material-icons-outlined">check_circle</span>
        </div>
        <div class="widget-content">
            <ul v-if="assignedActions.length">
                <li v-for="assignedAction in assignedActions" class="action-starred-item" :class="assignedActions.actionCurrentStatusClass">
                    <a :href="assignedAction.actionLink">
                    <span class="flex items-center">
                        <span class="material-icons-outlined">check_circle</span>
                        <span class="action-name">{{ assignedAction.reference }}</span>
                    </span>
                    <span class="action-status" :class="assignedAction.actionCurrentStatusClass">{{ $t('dashboard.widgets.shared.status.' + assignedAction.actionCurrentStatusLabel) }}</span>
                </a>
                </li>
            </ul>
            <div v-else>
                <p>{{ $t('dashboard.widgets.assigned.empty') }}</p>
            </div>
        </div>
    </div>
</template>
